const setMetaData = (data) => ({
    type: "META_DATA",
    data: data
})
const setMenu = (data) => ({
    type: "MENU",
    data: data
})

export {
   setMetaData, setMenu
}